var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3945 10.7495H21.2305L13.3945 2.97998V10.7495ZM17.6445 17.855V14.9995H6.35547V17.855H17.6445ZM17.6445 23.4995V20.644H6.35547V23.4995H17.6445ZM14.8555 0.85498L23.3555 9.35498V26.355C23.3555 27.1076 23.0677 27.7716 22.4922 28.3472C21.9167 28.8784 21.2526 29.144 20.5 29.144H3.5C2.7474 29.144 2.08333 28.8784 1.50781 28.3472C0.932292 27.7716 0.644531 27.1076 0.644531 26.355L0.710938 3.64404C0.710938 2.89144 0.976562 2.24951 1.50781 1.71826C2.08333 1.14274 2.7474 0.85498 3.5 0.85498H14.8555Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.5d845a24c1178ab3354576842bb9b1f0.svg";
export { ForwardRef as ReactComponent };